<template>
  <v-layout column text-xs-center _signup-parent-3>
      <v-flex class="_signup-parent-3--header">
          <h1>Great choice! You're one step closer to hiring <br/>your very own NannyGranny</h1>
          <app-svg-icon name="brand/NG_DIVIDER"
                        color="var(--green)"
                        :width="$vuetify.breakpoint.xsOnly ? '100' : '139'"></app-svg-icon>
      </v-flex>
      <!--ACCOUNT FORM-->
      <v-flex>
          <v-container grid-list-xl w--max--800>
              <v-layout row wrap>
                  <v-flex xs12 sm6>
                      <v-text-field label="First name*"
                                    v-model="user.first_name"
                                    v-validate="'required'"
                                    :error-messages="errors.first('first_name')"
                                    data-vv-name="first_name"
                                    ref="first_name"
                                    outline></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                      <v-text-field label="Last name*"
                                    v-model="user.last_name"
                                    v-validate="'required'"
                                    :error-messages="errors.first('last_name')"
                                    data-vv-name="last_name"
                                    ref="last_name"
                                    outline></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                      <v-text-field label="Mobile phone*"
                                    v-model="user.phone"
                                    v-validate="'required'"
                                    :error-messages="errors.first('phone')"
                                    data-vv-name="phone"
                                    ref="phone"
                                    placeholder="0123456789"
                                    :mask="maskPhone"
                                    outline></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6> 
                      <app-input-postcode label="Postcode*"
                                          v-model="postcode"
                                          v-validate="'required'"
                                          data-vv-name="postcode"
                                          ref="postcode"
                                          :hide-details="false"
                                          :error-messages="errors.first('postcode')"
                                          outline></app-input-postcode>
                  </v-flex>
                  <v-flex xs12 sm6>
                      <v-text-field label="Email*"
                                    v-model="user.email"
                                    :disabled="editingEmail"
                                    v-validate="'required|email'"
                                    :error-messages="errors.first('email')"
                                    data-vv-name="email"
                                    ref="email"
                                    outline></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                      <v-select 
                        label="How did you hear about us?" 
                        v-model="user.heard_from" 
                        :items="heardFromOptions"
                        item-value="id"
                        item-text="name"
                        :error-messages="errors.first('heard_from')"
                        v-validate="'required'"
                        data-vv-name="heard_from"
                        :menu-props="{ offsetY: true }"
                        outline>
                      </v-select>
                    </v-flex>
                  <v-flex xs12 md6 text-xs-left mt-3 px-3>
                      <!--<v-btn @click="editingEmail = !editingEmail">{{ editingEmail ? 'Cancel' : 'Change email'}}</v-btn>-->
                  </v-flex>
              </v-layout>
          </v-container>
      </v-flex>
      <!--PAYMENT-->
      <v-flex>
          <v-container w--max--800>
              <v-layout column>
                  <app-card-order-subscription></app-card-order-subscription>
              </v-layout>
          </v-container>
      </v-flex>
      <div id="head-choose-payment"></div>
      <v-flex xs12 tag="h2" class="my-5">Choose payment method</v-flex>
      <v-flex xs12>
          <v-container grid-list-xl w--max--800>
              <div id='cardData' style="text-align: center;"></div>
          </v-container>
      </v-flex>
      
      <v-flex class="text-xs-center pa-3">
          <v-btn @click="submit"
                 :loading="loading"
                 class="primary v-btn--default elevation-0 mt-5">
              Purchase
          </v-btn>
          <div class="v-text-field__details" v-if="isError()"><div class="v-messages theme--light error--text"><div class="v-messages__wrapper"><div class="v-messages__message">Missing information.</div></div></div></div>

      </v-flex>
      <!--BACKGROUND ELEMENTS-->
      <v-flex v-if="$vuetify.breakpoint.mdAndUp"
              class="_signup-parent-3--bg-elements">
          <app-svg-icon name="patterns/NG_Pattern-16"
                        color="none var(--orange)"
                        class="svg-icon--pattern-16"></app-svg-icon>
          <app-svg-icon name="brand/NG_JOIN_NETWORK"
                        color="var(--yellow)"
                        class="svg-icon--network"></app-svg-icon>
          <app-svg-icon name="brand/NG_ACTIVE"
                        color="var(--green)"
                        class="svg-icon--active"></app-svg-icon>
          <app-svg-icon name="brand/NG_CREATIVE_PLAY"
                        color="var(--orange)"
                        class="svg-icon--play"></app-svg-icon>
      </v-flex>
  </v-layout>
</template>

<script>

import AppCardOrderSubscription from '@/components/app-card/app-card-order-subscription'
import AppFormPaymentCreditCard from '../../../../../components/app-form/app-form-payment-credit-card'
import { MW_MERCHANT_UUID, MW_API_KEY, MW_TEST_MODE } from '../../../../../config/constants'
import Parent from '../../../../../models/user/ParentClass'
export default {
  name: 'auth-signup-step-3-parent',
  components: {AppFormPaymentCreditCard, AppCardOrderSubscription},
  data () {
    return {
      loading: false,
      editingEmail: false,
      maskPhone: '##########',
      user: {
        first_name: null,
        last_name: null,
        phone: null,
        email: null,
        postcode_id: null,
        heard_from: null
      },
      postcode: null,
      dictionary: {
        attributes: {
          first_name: 'first name',
          last_name: 'last name',
          phone: 'mobile phone'
        }
      },
      mwPayframe: null
    }
  },
  watch: {
    postcode () {
      this.user.postcode_id = this.$lodash.get(this.postcode, 'id', null)
    }
  },

  computed: {
    invoice () {
      return this.$store.getters['subscription/payments/invoice']
    },
    plan () {
      return this.$store.getters['subscription/selectedPlan']
    },
    heardFromOptions() {
      // console.log('HeardFrom Options:', this.$store.getters['heardFrom/list']);
      return this.$store.getters['heardFrom/list'];
    }
  },

  mounted () {
    this.$store.dispatch('heardFrom/HEARDFROM_GET')
        .catch(err => console.error('Error fetching heardFrom:', err));
    document.getElementById("cardData").innerHTML = ""; 
    const data = {
        plan_id: this.plan.id,
        summ: this.plan.price,
      }
      var button = document.getElementById("submitButton");
      let payframeScript = document.createElement('script');
      payframeScript.setAttribute('src', MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/payframe.js' : 'https://secure.merchantwarrior.com/payframe/payframe.js');
      document.head.appendChild(payframeScript);
      this.$store.dispatch('subscription/payments/ACCESS_TOKEN',data).then((data) => {
        var atoken = data.access_token;
        this.$auth.user(new Parent(data))
        
        add_card_dialog(atoken);
        //this.show_submit_button = true;
      });

    var add_card_dialog = (access_token) => {
        let checkInterval = setInterval(() => {
        let payframeScriptIsReady = false;
        if (typeof payframe !== 'undefined') {
          payframeScriptIsReady=true;
          clearInterval(checkInterval);
          setShowSubmitButton(false);
          var method = 'addCard'; // change this to getPayframeToken for payment payframe
          var threeDS = true; // this will only work with the getPayframeToken method
          var style = {
            fontFamily: 'Open Sans, sans-serif',
            fontSrc: ['https://fonts.googleapis.com/css?family=Open+Sans'],
          };
         // var accessToken = access_token;
         
          var accessToken = access_token;
         // alert(access_token);
        
         var submitURL = MW_TEST_MODE ? 'https://base.merchantwarrior.com/payframe/' : 'https://api.merchantwarrior.com/payframe/';

         var payframeObject = {
          accessToken: accessToken,
          payframeDivId: 'cardData',
          src: MW_TEST_MODE ? 'https://securetest.merchantwarrior.com/payframe/' : 'https://secure.merchantwarrior.com/payframe/',
          submitUrl: submitURL,
          style: style,
          method: method,
          };
          this.mwPayframe = new payframe(payframeObject);
          this.mwPayframe.deploy();
          mwPayframe.mwCallback = function() {
           // alert('1');
            //Example of success and error scenarios below
            if (threeDS) {
              //alert('1');
              processResponseEvent_recurring(method, arguments, tdsCheck);
            } else {
              processResponseEvent_recurring(method, arguments);
            }
          };

          
          
          this.mwPayframe.loading = function() {
            var mwIframe = document.getElementById("mwIframe");
            var cardDiv = document.getElementById("cardData");
            //alert();
            setShowSubmitButton(false);
            // Hide the payframe during load operations
            mwIframe.style.visibility = 'hidden';

            // Assign the parent div the same dimensions as the payframe
            var height = mwIframe.height;
            var width = mwIframe.width;

            cardDiv.style.height = height;
            cardDiv.style.width = width;

            // Place a loading animation in the center of the payframe
            cardDiv.style.background = "url('https://securetest.merchantwarrior.com/inc/image/loading_gif.gif') center center no-repeat";
          };

          this.mwPayframe.loaded = function() {
            //button.style.visibility = "visible";
            var mwIframe = document.getElementById("mwIframe");
            //alert('loaded');
            
            var cardDiv = document.getElementById("cardData");
            var cardloadedimg = document.getElementById("cardloadedimg");
            // Remove the loading animation after the payframe has completed its operations and display the payframe
            cardDiv.style.visibility = 'none';
            cardloadedimg.style.display  = 'none';
            if (mwIframe) {
              mwIframe.style.visibility = 'visible';
              setShowSubmitButton(true);
              console.log('Loaded');
              //alert('loaded');
            }
          }
        }
      },500);
      var setShowSubmitButton = (value) => {
        this.show_submit_button = value;
      }
      var processResponseEvent_recurring = (method, responseapi, tdsCheck) => {
        var responseCode = mwPayframe.responseCode;
        var responseMessage = mwPayframe.responseMessage;
        if (method == 'addCard') {
          var cardID = responseapi[0];
          var payframeToken = responseapi[1];
          var payframeKey = responseapi[2];
          console.log(responseapi);
          if (cardID && cardID != 'NO_TOKEN') {
            /*const data = {
            plan_id: 2,
            summ: '6.70',
            card_id: cardID
          }*/
          const data = {
            plan_id: this.plan.id,
            codenumber: this.plan.promocode,
            summ: this.plan.price,
            //payframe_token: payframeToken,
            //payframe_key: payframeKey,
            card_id: cardID,
            newuser_welcome: 1,
          }
          console.log(data);
        
            this.$store.dispatch('subscription/payments/CREDIT_CARD', data).then((data) => {
              if (data.status) {
                console.log(this.user);
                this.showSnackBar('Your payment was successful - welcome to NannyGranny!', 'success')
                setTimeout(() => {
                this.$auth.fetch({
                  enabled: true,
                  success: () => {
                    this.$cookie.set('rememberMe', 'false')
                    window.location = '/'
                  },
                  error: () => (this.$router.push('login'))
                })
              }, 4000)
              } else {
                this.showSnackBar(data.message, 'error')
                this.loading = false
              }

              setLoading(false);
              mwPayframe.reset();
              mwPayframe.deploy();
            })

          }else{
            this.loading = false;
            this.showSnackBar('Purchase could not progress. Please check credit card details.', 'error')
          } 
        }
      }


    }
    },

  created () {
    this.user.email = this.$auth.user().email
    this.plan = this.$auth.user().plan();
  },
  methods: {
    isError () {
      return this.errors.items.length > 0
    },
    scrollToFirstError() {
    // Find the first error field and scroll to it
    const errorFields = this.errors.items;
    if (errorFields.length > 0) {
      const firstErrorField = errorFields[0].field;
      const firstErrorElement = this.$refs[firstErrorField];
      if (firstErrorElement && firstErrorElement.$el) {
        firstErrorElement.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorElement.focus();
      }
    }
  },
    submit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true
          this.$store.dispatch('register/STEP_3', {data: this.user})
            .then(() => {
              // Purchase and finish register
              mwPayframe.submitPayframe(this)
            })
            .catch(error => {
              console.log(error);
              if (error.response.status === 422) {
                this.$lodash.forEach(error.response.data.errors, (val, key) => {
                  this.errors.add({
                    field: key,
                    msg: val[0]
                  })
                })
              }
              this.loading = false
            });
        }
        else{
          this.scrollToFirstError();
        }
      });
    }
  }
}

  // methods: {
  //   isError () {
  //     return this.errors.items.length > 0
  //   },
//     submit () {
//       this.$validator.validateAll().then(result => {
//         if (result) {
//           this.loading = true
//           this.$store.dispatch('register/STEP_3', {data: this.user})
//             .then(() => { 
//               // Purchase and finish register
//               mwPayframe.submitPayframe(this)
//             })
//             .catch(error => {
//               console.log(error);
//               if (error.response.status === 422) {
//                 this.$lodash.forEach(error.response.data.errors, (val, key) => {
//                   this.errors.add({
//                     field: key,
//                     msg: val[0]
//                   })
//                 })
//               }
//               this.loading = false
//             })
//         }
//       })
//     }
//   }
// }
</script>

<style lang="stylus" scoped>
  .container
    z-index auto
  ._signup-parent-3
      position relative
      padding-bottom 150px
      &--header .svg-icon
          margin 35px 0
      &--bg-elements
          .svg-icon
              position absolute
              &--pattern-16
                  width 110px
                  height 110px
                  top 80px
                  right 8%
                  transform rotate(40deg)
              &--network
                  width 90px
                  height 80px
                  top 35%
                  left 0
                  transform rotate(15deg)
                  @media (min-width 1200px)
                      left 5%
                      width 117px
              &--active
                  width 80px
                  height 116px
                  top 55%
                  right 0
                  @media (min-width 1200px)
                      right 5%
              &--play
                  width 80px
                  height 116px
                  top 85%
                  left 5%
</style>



// WEBPACK FOOTER //
// src/views/app/auth/signup/components/auth-signup-step-3-parent.vue